var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"homeSwiper",staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.list),function(carousel,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('a',{attrs:{"href":carousel.uri}},[_c('img',{attrs:{"src":carousel.logo}})])])}),0),_c('div',{staticClass:"swiper-pagination"})])
}
var staticRenderFns = []

export { render, staticRenderFns }